import { fetchFAQs, fetchFAQTags } from '../../clients/pages'
import { FaqEntry } from '../../types'
import { fromStrapiFaq, fromStrapiFaqTags} from '../../helpers/mapping/faq'
import { sortFaqEntries, sortFaqTagsAndEntries } from '../../helpers/utils/faq'
import { MembershipType } from '../../types/MembershipType'
import { StrapiFaqEntry } from '../../types/FaqEntry'
import { FaqTags, StrapiFaqTags } from '../../types/FaqTags'
import { isAccessible } from '../../helpers/utils/membershipScope'

class FaqRepository {
    async getAll(membershipType: MembershipType): Promise<FaqEntry[]> {
        const { data } = await fetchFAQs(membershipType)
        const allFaqEntries = data.map((i: StrapiFaqEntry) => fromStrapiFaq(i))
        const sortedFaqEntries = sortFaqEntries(allFaqEntries)
        return sortedFaqEntries
    }

    async getAllTags(membershipType: MembershipType): Promise<FaqTags[]> {
        const { data } = await fetchFAQTags(membershipType)
        const tags = data.map((i: StrapiFaqTags) => fromStrapiFaqTags(i))
        const tagsWithEntries = tags.filter((tag: FaqTags)=> tag.faqEntries && tag.faqEntries?.length > 0)
        const sortedFaqTags = sortFaqTagsAndEntries(tagsWithEntries)
        const filteredEntries = sortedFaqTags.map(faq => ({
            ...faq,
            faqEntries: faq.faqEntries?.filter(entry => isAccessible(entry.membershipScope, membershipType)),
        }))
        return filteredEntries
    }
}

export default FaqRepository